@for (levelRow of levelRows; track trackByFn($index, levelRow)) {
  <div [class.top-level-row-border]="border" [class.space-top]="spaceTop">
    <multilevel-toggle-line
      [levelRow]="levelRow"
      [withPaddingBottom]="withPaddingBottom"
      (change)="onChange($event.item)"
    />
  </div>
}
